import { Button } from "@/components/ui/button";
import { ArrowDown } from "lucide-react";
import { useLanguageStore } from "@/stores/language";
import { homeContent } from "@/data/content";
interface HeroSectionProps {
  onBrowseClick: () => void;
  onLearnMoreClick: () => void;
}
export const HeroSection = ({
  onBrowseClick,
  onLearnMoreClick
}: HeroSectionProps) => {
  const {
    t
  } = useLanguageStore();
  const {
    hero
  } = homeContent;
  return <section className="min-h-[100dvh] flex flex-col justify-center relative pt-20 overflow-hidden bg-black" aria-labelledby="hero-heading">

      <div className="relative z-10 container mx-auto px-6 py-16 md:py-24">
        <div className="max-w-6xl mx-auto">
          {/* Main headline - LCP element, render immediately with high priority */}
          <div className="mb-8 md:mb-12">
            <h1 id="hero-heading" className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl xl:text-9xl font-display font-bold tracking-tighter leading-[0.9] break-words" style={{
            contentVisibility: 'visible'
          }}>
              {t(hero.headline.line1)}
              <br />
              <span className="text-accent">{t(hero.headline.line2)}</span>
            </h1>
          </div>

          {/* Subtitle and CTA - NO animation wrapper for LCP optimization */}
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 md:gap-8">
            <p className="text-lg md:text-xl text-muted-foreground max-w-md">
              {t(hero.subtitle)}
            </p>

            <div className="flex flex-col gap-4 w-full xs:w-auto">
              {/* CHIMERA™ system badge */}
              <div className="gap-3 flex items-center justify-center">
                <div className="h-px flex-1 max-w-[40px] bg-muted-foreground/30" />
                <span className="text-xs font-mono tracking-widest text-muted-foreground uppercase text-center">
                  {t("Powered by the CHIMERA™ Prompt System", "Impulsado por el CHIMERA™ Prompt System")}
                </span>
                <div className="h-px flex-1 max-w-[40px] bg-muted-foreground/30" />
              </div>

              <div className="flex flex-col xs:flex-row gap-3 sm:gap-4 w-full xs:w-auto">
              <Button size="lg" onClick={onBrowseClick} className="group text-sm md:text-base font-body touch-action-manipulation whitespace-normal text-center leading-snug">
                {t(hero.buttons.browse)}
              </Button>
              <Button size="lg" variant="outline" onClick={onLearnMoreClick} className="text-base font-body touch-action-manipulation">
                {t(hero.buttons.learnMore)}
              </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator - delayed to not block main content */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-fade-in" style={{
      animationDelay: '0.5s'
    }}>
        <div className="flex flex-col items-center gap-2 text-muted-foreground animate-bounce">
          <span className="text-xs font-mono uppercase tracking-widest">{t(hero.scrollIndicator)}</span>
          <ArrowDown className="w-4 h-4" />
        </div>
      </div>
    </section>;
};